'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ClientRadioCheckbox = require('./ClientRadioCheckbox.less');

var _ClientRadioCheckbox2 = _interopRequireDefault(_ClientRadioCheckbox);

var _ClientRadioCheckbox3 = require('../../logic/ClientRadioCheckbox/ClientRadioCheckbox.js');

var logic = _interopRequireWildcard(_ClientRadioCheckbox3);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function (_React$Component) {
    (0, _inherits3.default)(_default, _React$Component);

    function _default() {
        (0, _classCallCheck3.default)(this, _default);
        return (0, _possibleConstructorReturn3.default)(this, (_default.__proto__ || (0, _getPrototypeOf2.default)(_default)).apply(this, arguments));
    }

    (0, _createClass3.default)(_default, [{
        key: 'render',

        // TODO this isn't only viewed under item view, can I remove this?
        // static displayName = 'ItemView.ClientRadioCheckbox';

        // static propTypes = logic.propTypes;

        value: function render() {

            var background = this.props.backgroundColor;
            var border = this.props.borderColor;
            var active = this.props.activeColor;

            var checkedSvgStyle = { stroke: active, fill: active, strokeWidth: 2 };
            var checkedBorderStyle = { stroke: active, fill: background, strokeWidth: 2 };
            var uncheckedBorderStyle = { stroke: border, fill: background, strokeWidth: 2 };
            var uncheckedBorderStyleWithFill = { stroke: active, fill: background, strokeWidth: 2 };

            var borders = null;
            var inner = null;

            if (this.props.type === 'checkbox') {
                if (this.props.checked) {
                    borders = _react2.default.createElement(
                        'g',
                        null,
                        _react2.default.createElement('rect', { x: 1, y: 1, width: 14, height: 14, style: uncheckedBorderStyle, className: _ClientRadioCheckbox2.default.shownothover }),
                        _react2.default.createElement('rect', { x: 1, y: 1, width: 14, height: 14, style: checkedBorderStyle, className: _ClientRadioCheckbox2.default.showhover })
                    );
                    inner = _react2.default.createElement(
                        'g',
                        null,
                        _react2.default.createElement('line', { x1: 5, y1: 7, x2: 8, y2: 11, style: checkedSvgStyle }),
                        _react2.default.createElement('line', { x1: 8, y1: 11, x2: 11, y2: 4, style: checkedSvgStyle })
                    );
                } else {
                    borders = _react2.default.createElement(
                        'g',
                        null,
                        _react2.default.createElement('rect', { x: 1, y: 1, width: 14, height: 14, style: uncheckedBorderStyle, className: _ClientRadioCheckbox2.default.shownothover }),
                        _react2.default.createElement('rect', { x: 1, y: 1, width: 14, height: 14, style: uncheckedBorderStyleWithFill, className: _ClientRadioCheckbox2.default.showhover })
                    );
                }
            } else {
                if (this.props.checked) {
                    borders = _react2.default.createElement(
                        'g',
                        null,
                        _react2.default.createElement('circle', { cx: 8, cy: 8, r: 7, style: uncheckedBorderStyle, className: _ClientRadioCheckbox2.default.shownothover }),
                        _react2.default.createElement('circle', { cx: 8, cy: 8, r: 7, style: uncheckedBorderStyle, className: _ClientRadioCheckbox2.default.showhover })
                    );
                    inner = _react2.default.createElement(
                        'g',
                        null,
                        _react2.default.createElement('circle', { cx: 8, cy: 8, r: 2, style: checkedSvgStyle })
                    );
                } else {
                    borders = _react2.default.createElement(
                        'g',
                        null,
                        _react2.default.createElement('circle', { cx: 8, cy: 8, r: 7, style: uncheckedBorderStyle, className: _ClientRadioCheckbox2.default.shownothover }),
                        _react2.default.createElement('circle', { cx: 8, cy: 8, r: 7, style: uncheckedBorderStyleWithFill, className: _ClientRadioCheckbox2.default.showhover })
                    );
                }
            }

            return _react2.default.createElement(
                'div',
                { className: _ClientRadioCheckbox2.default.openrest_ClientRadioCheckbox_wrapper },
                _react2.default.createElement(
                    'svg',
                    { height: 16, width: 16 },
                    borders,
                    inner
                )
            );
        }
    }]);
    return _default;
}(_react2.default.Component);

exports.default = _default;